import withQuery from 'with-query'
import {access} from '@rambler-id/react-utils'
import redirect from 'utils/redirect'
import {LOGIN} from 'utils/urls'

export default access(
  ({type}) => !!type,
  () => redirect(withQuery(LOGIN, {back: window.location.href})),
  (nextProps, props) => nextProps.type !== props.type
)
